<div
  @click="onClick"
  class="ml-auto font-bold underline text-qr_color-blue_1 hover:cursor-pointer"
  :class="className"
  v-if="!hide"
>
  {{label}}
</div>
